// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-url-icon svg[data-v-dd51c132] {\n  font-size: 80px;\n}\n[data-v-dd51c132] .disabled {\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
